import {commitMutation, graphql} from 'react-relay';
import type {Environment, Disposable} from 'relay-runtime';
import {csrfToken, socketClientId} from '../../../forecast-app/ticketing/graphql/forecastRelay';
import type {
	regenerateTicketAiSummaryMutation,
	RegenerateTicketAiSummaryInput,
} from './__generated__/regenerateTicketAiSummaryMutation.graphql';

// ACC-297: synchronous regenerate. The backend awaits the generation job and
// returns the fully hydrated ticket node, so spreading BOTH AI block fragments
// lets one mutation refresh the summary block and the action-items list at once.
const mutation = graphql`
	mutation regenerateTicketAiSummaryMutation($input: RegenerateTicketAiSummaryInput!) {
		regenerateTicketAiSummary(input: $input) {
			clientMutationId
			ticket {
				id
				...AiSummaryBlock_ticket
				...AiSuggestedActionsList_ticket
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: RegenerateTicketAiSummaryInput,
	onCompleted?: (r: regenerateTicketAiSummaryMutation['response']) => void,
	onError?: (e: Error) => void
): Disposable {
	return commitMutation<regenerateTicketAiSummaryMutation>(environment, {
		mutation,
		variables: {
			input: {csrfToken: csrfToken(), socketClientId: socketClientId(), ...input},
		},
		onCompleted: onCompleted ? response => onCompleted(response) : undefined,
		onError: onError ? error => onError(error) : undefined,
	});
}

export default {commit, mutationId: 'regenerateTicketAiSummaryMutation'};
